import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

// API
import { requestAssistantAccessClick } from 'Shared/api';

// Components
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpButton } from 'Wpds/components/button';
import { WpBadge } from 'Wpds/components/badge';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

import './AssistantCard.scss';

type Props = {
  title: string;
  description: string;
  image: Illustrations;
  path: string;
  showComingSoon?: boolean;
};

const AssistantCard = ({ title, description, image, path, showComingSoon = false }: Props) => {
  const history = useHistory();

  const handeViewClick = useCallback(() => {
    history.push(path);
  }, []);

  const onRequestAccess = () => {
    requestAssistantAccessClick({ assistantType: title });
  };

  const baseClassName = 'AssistantCard';

  return (
    <WpCard className={baseClassName}>
      <WpCardBody className={`${baseClassName}__body`} centered>
        <div className={`${baseClassName}__body__wrapper__image`}>
          <WpIllustration className={`${baseClassName}__body__wrapper__image`} src={image} alt={title} />
        </div>
      </WpCardBody>
      <WpCardBody className={`${baseClassName}__details-body`}>
        <h4 className={`${baseClassName}__title`}>
          {title}
          {showComingSoon && (
            <span className={`${baseClassName}__title__badge`}>
              <WpBadge color="purple" variant="bold">
                Coming Soon
              </WpBadge>
            </span>
          )}
        </h4>
        <p className={`${baseClassName}__description`}>{description}</p>
        {showComingSoon ? (
          <WpButton size="lg" block onClick={onRequestAccess} variant="secondary">
            Request Access
          </WpButton>
        ) : (
          <WpButton size="lg" block onClick={handeViewClick}>
            View
          </WpButton>
        )}
      </WpCardBody>
    </WpCard>
  );
};

export default AssistantCard;
